import { getTermsValue } from '@/packages/JsonQuery';
import { EParkingType } from '@/packages/api-models/common/json_query';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagParkingTypeSchema } from '../types';

const TEXT_MAP: { [key in EParkingType]: string | null } = {
  [EParkingType.AllTypes]: null,
  [EParkingType.Ground]: 'Наземная парковка',
  [EParkingType.Multilevel]: 'Многоуровневая парковка',
  [EParkingType.Underground]: 'Подземная парковка',
  [EParkingType.Rooftop]: 'Парковка на крыше',
};

export const parkingType: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value: EParkingType[] = getTermsValue('parking_type')(jsonQuery) || [];

    const tagsGroup = value.reduce<TagParkingTypeSchema[]>((acc, key) => {
      const text = TEXT_MAP[key];
      if (!text) {
        return acc;
      }

      acc.push({
        group: 'parkingType',
        text,
        data: key,
      });

      return acc;
    }, []);

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagParkingTypeSchema) {
    const currentValue = getTermsValue('parking_type')(jsonQuery) || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setParkingType',
      arguments: [nextValue],
    });
  },
};
